// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-5bfce1a6]{fill:#404040}.cls-2[data-v-5bfce1a6],.cls-3[data-v-5bfce1a6]{fill:#fff3e7}", ""]);
// Exports
module.exports = exports;
